import { setupLocales } from '@webnuts/component-factories/build/setup-locales'
import { common } from './common'

const initialLocale = 'da-DK'
const initialFormat = 'da-DK'
const initialTimezone = 'Europe/Copenhagen'

export const { LocaleProvider, useLocale } = setupLocales({
  locales: ['da-DK'],
  initial: { locale: initialLocale, format: initialFormat, timeZone: initialTimezone },
  source: {
    common
  }
})
